// extracted by css-extract-rspack-plugin
export default {"size200":"200px","smallColumn":"additional-job-information__smallColumn___NghVz"};